import { render, staticRenderFns } from "./LicenseWriteComponent.vue?vue&type=template&id=13d8b9d5&scoped=true&"
import script from "./LicenseWriteComponent.vue?vue&type=script&lang=js&"
export * from "./LicenseWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8b9d5",
  null
  
)

export default component.exports